import { IApplicationState } from '../../types/redux';
import { getAnswerById } from './getAnswerById';

export const getIsAnswerAuthorAnonymousById =
  (id: string) =>
  (state: IApplicationState): boolean => {
    const answer = getAnswerById(id)(state);

    return answer?.isAnonymous || false;
  };
